module.exports = __webpack_public_path__ + "img/online-blue.0c944551.svg";